import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import businessTravelIcon from "../../../../../assets/design-revamp-company/company-detail-headers/business-travel-icon.svg";
import { useTranslation } from "react-i18next";
import { getTravelList } from "../../../../../apis/Business/TravelApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";

const TravelIcon = () => (
  <img src={businessTravelIcon} alt="Travel Icon" width={76} height={76} />
);

const TravelHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjTravelHotel, setTotalObjTravelHotel] = useState([]);
  const [systemBoundaryTravelHotel, setSystemBoundaryTravelHotel] =
    useState("");
  useEffect(() => {
    getTravelList({
      businessId: businessId,
      setTotalObj: setTotalObjTravelHotel,
      setSystemBoundaryTravelHotel: setSystemBoundaryTravelHotel,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`travel-category ${className || ""}`}
      leftBoxProps={{
        icon: <TravelIcon />,
        title: t("BUSINESS_TRAVEL"),
        description: t("BUSINESS_TRAVEL_INTRO"),
        scopes: [{ scope: t("TRAVEL_HOTEL_SCOPE"), filled: true }],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: "Total for the lifecycle phase",
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjTravelHotel,
                      totalObjTravelHotel?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjTravelHotel,
                      totalObjTravelHotel?.total_emissions
                    ),
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjTravelHotel?.updated_at
          ? formatDate(totalObjTravelHotel?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      systemBoundaryProps={{
        systemBoundary: systemBoundaryTravelHotel,
        setSystemBoundary: setSystemBoundaryTravelHotel,
        businessId: businessId,
        totalObjCategory: totalObjTravelHotel.category_name,
      }}
      {...props}
    />
  );
};

export default TravelHeader;
